import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Tells the apps which screen this one depends on (parent-screen bridge): a product's list,
// for instance. The apps use it so that going back leads to that screen when arriving from
// elsewhere — notification, external link, share — instead of returning where the user came
// from with no way to reach the parent content.
//
// Set on the <body> of pages that declare :native_parent_path (see body_bridge_attributes).
export default class extends BridgeComponent {
  static component = 'parent-screen'
  static values = { url: String }

  connect() {
    super.connect()
    this.send('connect', { url: this.urlValue })
  }
}
